import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import styled from "styled-components"
import DefaultLayout from "../components/molecules/common/DefaultLayout"
import ErrorableInputWrapper from "../components/molecules/common/ErrorableInputWrapper"
import ClearableInput from "../components/molecules/ClearableInput"
import PasswordInput from '../components/molecules/auth/PasswordInput';
import Text from '../components/atoms/Text';
import MainButton from '../components/atoms/MainButton';
import { loginUser } from '../api/auth';
import ChannelService from '../ChannelService';
import { logEvent } from '../utils/eventLogger';

const Wrapper = styled.form`
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`
const Logo = styled.p`
  margin-top: 120px;
  margin-bottom: 72px;
  font-family: Cafe24Decobox;
  font-size: 36px;
`
const OtherMenus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  button {
    background: none;
    border: none;
    cursor: pointer;
  }
`
const Separator = styled.span`
  display: inline-block;  
  width: 2px;
  height: 14px;
  background-color: ${({ theme }) => theme.colors.neutral[400]};
  margin: 0 8px;
  border: none;
  pointer-events: none;
`

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError]= useState("")

  const handleEmail = (e) => {
    setEmail(e.target.value)
  }
  const handlePassword = (e) => {
    setPassword(e.target.value)
  }

  const handleSubmit = async(e) => {
    e.preventDefault();
    const data = {
      email,
      password
    };

    try {
      ChannelService.shutdown();
      // ChannelService.clearChannelCookies();
      
      await loginUser(data)
      // 아이등록에 필요한 유저 정보 필요 -> ex. 회원가입 api 호출 시 로그인 토큰 반환, 자동 로그인
      // console.log('로그인 성공')
      
      // 로그 기록
      logEvent("login", {
        extractChildId: false
      })
      
      navigate('/')

      // window.location.href = '/';
    } catch (err) {
      if (err.response.status === 401) {
        setError('이메일 또는 비밀번호를 틀렸어요.')
      }
      // console.log(err)
      console.error(err);
      // console.log('로그인 실패')
    }
  }

  return (
    <DefaultLayout>
      <Wrapper onSubmit={handleSubmit}>
        <Logo>Tickle Talk</Logo>
        <ErrorableInputWrapper>
          <ClearableInput
            name="email"
            placeholder="이메일 계정"
            value={email}
            onChange={handleEmail}
            autoComplete="email"/>
        </ErrorableInputWrapper>
        <ErrorableInputWrapper message={error} $error={!!error}>
          <PasswordInput
            name="password"
            placeholder="비밀번호"
            value={password}
            onChange={handlePassword}
            autoComplete="current-password"/>
        </ErrorableInputWrapper>
        <MainButton
          title="로그인"
          type="submit"/>
      </Wrapper>
      <OtherMenus>
        <button
          onClick={() => {
            logEvent("signup_start", {
              extractChildId: false
            })
            navigate('/signup/email-verification')
          }}
        >
          <Text
            variant="caption" 
            color="assistive">
            이메일로 회원가입
          </Text>
        </button>
        <Separator/>
        <button onClick={() => navigate('/reset-password')}>
          <Text
            variant="caption" 
            color="assistive">
            비밀번호 찾기
          </Text>
        </button>
      </OtherMenus>
    </DefaultLayout>
  )
}

export default Login
